import * as React from "react";
import type { SVGProps } from "react";
const SvgTarget03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M13 5.2V1m0 24v-4.2m7.8-7.8H25M1 13h4.2m17.4 0a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 0 1 19.2 0Z"
    />
  </svg>
);
export default SvgTarget03;
